// Shared font + color presets for Briefkopf / Seitenkopf / Fußzeile cells
// Used by BriefkopfDesigner (editor + preview) and A4Sheet (final render)

export const FONTS = [
  { value: "sans",       label: "Sans Modern",  css: "'IBM Plex Sans', sans-serif" },
  { value: "serif",      label: "Serif Klassik", css: "'Cormorant Garamond', 'Times New Roman', serif" },
  { value: "georgia",    label: "Georgia",       css: "Georgia, 'Times New Roman', serif" },
  { value: "helvetica",  label: "Helvetica",     css: "Helvetica, Arial, sans-serif" },
  { value: "mono",       label: "Monospace",     css: "'IBM Plex Mono', monospace" },
];

// Body fonts (for the schriftsatz article text — typically serif)
export const BODY_FONTS = [
  { value: "serif",     label: "Cormorant Garamond",  css: "'Cormorant Garamond', 'Times New Roman', serif" },
  { value: "times",     label: "Times New Roman",     css: "'Times New Roman', Times, serif" },
  { value: "georgia",   label: "Georgia",             css: "Georgia, 'Times New Roman', serif" },
  { value: "sans",      label: "IBM Plex Sans",       css: "'IBM Plex Sans', sans-serif" },
  { value: "helvetica", label: "Helvetica",           css: "Helvetica, Arial, sans-serif" },
  { value: "arial",     label: "Arial",               css: "Arial, Helvetica, sans-serif" },
  { value: "calibri",   label: "Calibri",             css: "Calibri, 'Trebuchet MS', sans-serif" },
];

export const COLOR_PRESETS = [
  "#0A192F", // deep navy (default body)
  "#1A2238", // brand navy
  "#D32F2F", // accent red
  "#4B5563", // slate
  "#6B7280", // grey
  "#16A34A", // green
  "#000000", // black
];

export const DEFAULT_FONT = "sans";
export const DEFAULT_COLOR = "#0A192F";

export const DEFAULT_BODY_TYPO = { font_family: "serif", font_size: 11, line_height: 1.6 };

export const fontCss = (key) =>
  FONTS.find(f => f.value === key)?.css || FONTS[0].css;

export const bodyFontCss = (key) =>
  BODY_FONTS.find(f => f.value === key)?.css || BODY_FONTS[0].css;
